export default __webpack_public_path__ + "static/media/bank-woonkamer.c32f08b3.jpg";